import {parseScreenplay,type ScreenplayFormat}from './screenplayParser';
import {screenplayExtension,validateScreenplayFile}from './screenplayLimits';
export async function importScreenplayFile(file:File,onProgress?:(message:string)=>void,signal?:AbortSignal){
 signal?.throwIfAborted();
 const invalid=validateScreenplayFile(file.name,file.size);if(invalid)throw new Error(invalid);
 if(screenplayExtension(file.name)==='pdf')return (await import('./pdfScreenplay')).parsePdfScreenplay(file,onProgress,signal);
 const text=await file.text();signal?.throwIfAborted();return parseScreenplay(text,screenplayExtension(file.name) as ScreenplayFormat);
}
